// =============================================================================
// THE application version. Single source of truth.
//
// It used to live in two places that could not see each other and never agreed:
//   - ngsw-config.json  "appData": { "version": "4.5.12" }, set once on
//     2026-03-13 (git log -S '"version"' -- ngsw-config.json returns exactly one
//     commit) and never bumped by anything in the build.
//   - package.json      "version": "0.0.0", the ng-new default.
//
// The menu's "Version: X" line read the first of those THROUGH the service
// worker, so it reported a string frozen since March 2024 on production, and
// nothing at all anywhere the worker is not registered — which is every DEV
// build, since ServiceWorkerModule registers on `environment.production` and
// environment.devTOTP.ts sets that false.
//
// Now: bump this constant, and run
//   node src/app/version.verify.mjs
// which fails if package.json or ngsw-config.json has drifted from it. That
// check is the only thing keeping the three in step, so run it when you bump.
//
// NOTE this identifies the RELEASE, not the build. Two deploys of the same
// version string are indistinguishable here. Per-build identification needs a
// release process that stamps a commit sha, which this repo does not have yet.
// =============================================================================
export const APP_VERSION = '4.5.12';
